import { Badge, Col, Flex, Modal, Row, Space, Tooltip } from "antd";
import cx from "classnames";
import { Button } from "components/elements";
import {
  DatePicker,
  Input,
  RadioGroup,
  Select,
  TimePicker
} from "components/form";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/leaveSchema";

import { CloudUploadOutlined, InfoCircleOutlined, MoreOutlined, } from "@ant-design/icons";
import { Card, Checkbox, ConfigProvider, Tabs } from "antd/lib";
import Dragger from "antd/lib/upload/Dragger";
import StatusTag from "components/elements/TagCustom/StatusTag";
import i18n from "i18n";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { dataURLtoFile, generateRandomString } from "utils/helper";
import { MY_REQUEST_TYPE } from "../schemas/myRequestSchema";
import * as services from "../services/myDocumentApi";
import styles from "./Input.module.css";
import { REQUEST_APPROVE_TAB } from "features/requestApproval/schemas/RequestApproveTab";

function formatDate(dateString) {
  if (!dateString) return;
  const date = dayjs(dateString);
  return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
}

function formatDateTime(dateString) {
  if (!dateString) return;
  const date = dayjs(dateString);
  return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD/MM/${date.year() + 543} HH:mm`);
}

const MODAL_TYPE = {
  CREATE: "create",
  EDIT: "edit",
  VIEW: "view",
};

function LeaveForm({
  className = "",
  modalType = "",
  leaveGroupOptions = [],
  initialValues = {},
  onDraft = () => { },
  onCancel = () => { },
  onDeleteFile = () => { },
  onSubmit = () => { },
  setremainingLeaveDays = () => { },
  onAttachFileChange = () => { },
  standAlone = true,
  approvalPage = false,
  approveType = "",
  onApprove = () => { },
  onReject = () => { },
  onDelete = () => { },
}) {

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  // console.log("leaveGroupOptions", leaveGroupOptions);
  function base64ToFile(base64String, fileName, mimeType = 'application/octet-stream') {
    const byteCharacters = atob(base64String);
    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: mimeType });
    return new File([blob], fileName, { type: mimeType });
  }

  const { t, i18n } = useTranslation();
  // const [selectedLeaveType, setSelectedLeaveType] = useState(null);
  const [remainingLeaveDays, setRemainingLeaveDays] = useState(0);
  const [remainingLeaveHour, setRemainingLeaveHour] = useState(0);
  // const [emergencyLeave, setEmergencyLeave] = useState('N');
  // const [annualLeaveLimit, setAnnualLeaveLimit] = useState(0);
  // const [emerUsed, setEmerUsed] = useState(0);
  const [fileSizeInMB, setfileSizeInMB] = useState([])
  const [fileName, seeFileName] = useState([]);
  const [imageUrl, setImageUrl] = useState([]);
  const [fileType, setFileType] = useState([]);
  const [initialValuesFileName, setInitialValuesFileName] = useState([]);
  const [initialValuesImageUrl, setInitialValuesImageUrl] = useState([]);
  const [initialValuesFileType, setInitialValuesFileType] = useState([]);
  const [initialValuesFileList, setInitialValuesFileList] = useState([]);
  const [useCurrentMenu, setCurrentMenu] = useState(MY_REQUEST_TYPE.DETAIL);
  const [selectedMenu, setMenu] = useState(MY_REQUEST_TYPE.DETAIL);
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const currentEmployee = useSelector((state) => state.company.currentEmployee);
  const [currentWorkflow, setCurrentWorkflow] = useState([]);
  const [listEmployees, setListEmployees] = useState({});
  const [openListEmployee, setOpenListEmployee] = useState(false);
  const [resetFn, setResetFn] = useState(() => { });

  const convertLeaveHour = (remainingLeaveHour) => {
    if (remainingLeaveHour === t("unlimited")) return t("unlimited");

    const leaveHour = parseFloat(remainingLeaveHour);

    if (!isNaN(leaveHour)) {
      if (leaveHour !== 0) {
        const hourPart = Math.floor(leaveHour);
        const decimalPart = leaveHour % 1;
        const minutes = Math.round(decimalPart * 60);
        const convertedMinutes = (minutes) / 100;

        return `${(hourPart + convertedMinutes).toFixed(2)}`;
      }
      return `0.00`;
    }

    return remainingLeaveHour;
  };

  function initData() {
    console.log("initialValues", initialValues);

    if (typeof initialValues?.startDate == String) {
      initialValues.startDate = dayjs(initialValues?.startDate, 'yyyy-mm-dd')
    } else {
      initialValues.startDate = dayjs(initialValues?.startDate)
    }
    if (typeof initialValues?.endDate == String) {
      initialValues.endDate = dayjs(initialValues?.endDate, 'yyyy-mm-dd')

    } else {
      initialValues.endDate = dayjs(initialValues?.endDate)
    }
    initialValues.leaveTypeId = initialValues?.leaveType?.leaveTypeId
    initialValues.createDate = dayjs(initialValues?.createDate)
    initialValues.totalLeaveHourShow = convertLeaveHour(initialValues?.totalLeaveHour)

    // console.log("🚀 ~ initData ~ initialValues?.timeShiftDtos:", initialValues?.timeShiftDtos)

    const timeShiftDtosTH = initialValues?.timeShiftDtos?.map((item, index) =>
      `${index + 1}. ${formatDate(item?.date)} ${i18n.language === "EN" ? item.shiftNameEn : item.shiftName} ${item.workTimeStart} - ${item.workTimeEnd}`
    ).join("\n");
    initialValues.timeShiftDtosTH = timeShiftDtosTH
  }

  const openBase64InNewTab = (base64Data, mimeType = "application/pdf", fileType) => {
    // Remove data URL prefix if it exists
    console.log("fileType", fileType);
    const base64 = base64Data.includes(",")
      ? base64Data.split(",")[1]
      : base64Data;

    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl, "_blank", "noopener,noreferrer");

    // Optional: release memory after some time
    setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
  };

  useMemo(() => {
    if (initialValues) {
      console.log("initialValues", initialValues);

      initData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues])

  function fnRejectFor(initialValues) {
    let language = i18n.language === 'en' ? "En" : ""

    let condition = initialValues?.rejectWorkflow?.length > 0 ? 1 : 2
    let data = {}
    if (condition == 1) {
      data = initialValues?.rejectWorkflow.map((o, index) => {
        let rejectFlow = initialValues.timelineReject.filter(o => o.approveStatusEn != 'Pending')
        return {
          ...o,
          date: rejectFlow?.[index]?.date ?? null,
          approveStatusEn: rejectFlow?.[index]?.approveStatusEn ?? "Pending",
          approveStatus: rejectFlow?.[index]?.approveStatus ?? "รออนุมัติคำขอ"
        }
      })
    } else {
      data = initialValues.timelineReject
    }

    const hasRejectedStatus = initialValues.timelineReject?.some(item =>
      (item.approveStatusEn === "Rejected"));

    return data?.map((workflow, index) => {
      const isPending = workflow?.approveStatusEn === "Pending";

      const shouldShowGrayStatus = isPending && hasRejectedStatus;

      return (
        <>
          <label>{`${t('leave_type.label.sequence')} ${index + 1}`}</label>
          <Card size="small" key={index} style={{ border: "1px solid #000" }}>
            <Row>
              <Col span={16}>
                <label style={{ color: "#667085" }}>{`${t('leave_type.label.approver')}`}</label>
              </Col>
              <Col span={8}>
                <span style={{ color: "#667085", display: "flex", justifyContent: "flex-end" }}>{t("leave_type.label.approvalDate")}</span>
              </Col>
              <Col span={16}>
                <span>{i18n.language === "en" ? workflow?.employee?.nameAndSurnameEn : workflow?.employee?.nameAndSurname}</span>
              </Col>
              <Col span={8}>
                <span style={{ display: "flex", justifyContent: "flex-end" }}>{workflow?.date ? formatDateTime(workflow?.date) : "-"}</span>
              </Col>
              <Col span={16} style={{ marginTop: '10px' }}>
                <span>{i18n.language === "en" ? workflow?.employee?.position?.positionNameEn : workflow?.employee?.position?.positionName}</span>
              </Col>
              <Col span={8} style={{ marginTop: '10px' }}>
                <label style={{ display: "flex", justifyContent: "flex-end" }}>
                  {shouldShowGrayStatus ?
                    <Badge color="#667085" text={workflow?.["approveStatus" + language]} style={{ backgroundColor: "#EAEBEC", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} /> :
                    <StatusTag value={(workflow?.["approveStatus" + language])} />
                  }
                </label>
              </Col>
            </Row>
          </Card>
        </>
      );
    });
  }

  useEffect(() => {
    if (initialValues?.attachFile && initialValues?.attachFile?.[0] || initialValues?.attachFileFs) {
      const fileUrls = [];
      const fileNames = [];
      const fileSizes = [];
      const fileTypes = [];
      const fileList = []

      console.log("initialValues?.attachFileFs", initialValues?.attachFile?.length, initialValues?.attachFileFs);

      for (let index = 0; index < initialValues?.attachFile?.length; index++) {
        const fileByte = initialValues?.attachFile[index];
        const fileType = initialValues?.attachFileType?.[index];
        const fileName = initialValues?.attachFileName?.[index];

        if (typeof fileByte === "string") {
          const blob = new Blob(
            [Uint8Array.from(atob(fileByte), (c) => c.charCodeAt(0))],
            { type: fileType }
          );
          const fileUrl = URL.createObjectURL(blob);
          const fileSizeInMB = (blob.size / (1024 * 1024)).toFixed(2);

          // เพิ่มค่าลงใน array
          fileTypes.push(fileType);
          fileUrls.push(fileUrl);
          fileNames.push(fileName);
          fileSizes.push(fileSizeInMB);
        }

        const dataURL = `data:${fileType};base64,${fileByte}`;
        const file = dataURLtoFile(dataURL, fileName);
        fileList.push(file)

      }

      for (let index = 0; index < initialValues?.attachFileFs?.length; index++) {
        const fileByte = initialValues?.attachFileFs?.[index]?.fileByte;
        const fileType = initialValues?.attachFileFs?.[index]?.fileType;
        const fileName = initialValues?.attachFileFs?.[index]?.fileName;

        if (typeof fileByte === "string") {
          const blob = new Blob(
            [Uint8Array.from(atob(fileByte), (c) => c.charCodeAt(0))],
            { type: fileType }
          );
          const fileUrl = URL.createObjectURL(blob);
          const fileSizeInMB = (blob.size / (1024 * 1024)).toFixed(2);

          // เพิ่มค่าลงใน array
          fileTypes.push(fileType);
          fileUrls.push(fileUrl);
          fileNames.push(fileName);
          fileSizes.push(fileSizeInMB);
        }

        const dataURL = `data:${fileType};base64,${fileByte}`;
        const file = dataURLtoFile(dataURL, fileName);
        fileList.push(file)

      }

      // Set state หลังจากวนลูปเสร็จ
      setFileType(fileTypes)
      setImageUrl(fileUrls);
      seeFileName(fileNames)
      setInitialValuesFileName(fileNames)
      setInitialValuesImageUrl(fileUrls)
      setInitialValuesFileList(fileList)
      setInitialValuesFileType(fileTypes)
      setfileSizeInMB(fileSizes);
    } else {
      setImageUrl(null);
    }

    getWorkflow();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCompany, currentEmployee, initialValues, modalType]);


  const getWorkflow = useCallback(async () => {
    let data = [];
    if (modalType === MODAL_TYPE.VIEW && initialValues?.approveStatusEn !== 'Draft') {
      data = await services.getWorkflowByRequestId({
        requestId: generateRandomString(),
        companyId: currentCompany,
        employeeId: initialValues?.employeeId?.employeeId,
        flowRequestId: initialValues?.leaveRequestId,
      });
      setCurrentWorkflow(data?.data?.approvalSequence)
    }
  }, [currentCompany, initialValues, modalType])

  const validateDaysMin = useCallback(
    (values) => {
      if (values?.emergencyFlag != 'Y') {
        if (values?.requestCondition?.code == 'LEAVE_REQUEST_CONDITION_01') {

          return dayjs().startOf("year").add(values?.advanceAtLeast, 'day')
        }
        if (values?.requestCondition?.code == 'LEAVE_REQUEST_CONDITION_02') {
          return dayjs().startOf("year").subtract(values?.backDateWithin, 'day')
        } else {
          return dayjs().startOf("year")
        }
      } else {
        return dayjs().startOf("year")
      }

    },
  );
  const validateDaysMax = useCallback(
    (values) => {
      if (values?.emergencyFlag != 'Y') {
        if (values?.consecutiveLimit == 'Y') {
          return dayjs(values?.startDate).add(values?.maximumConsecutiveLeave ? values?.maximumConsecutiveLeave - 1 : 0, 'day')
        } else {
          return
        }
      } else {
        return
      }
    },
  );

  const calculateMinStartDate = useCallback((values) => {
    return dayjs().startOf("year")
  }, []);

  const calculateMaxStartDate = useCallback((values) => {
    return dayjs().endOf("year")
  }, [])

  const calculateMinEndDate = useCallback((values) => {
    if (values?.startDate) {
      return values?.startDate
    }
  }, []);

  const calculateMaxEndDate = useCallback((values) => {
    return dayjs().endOf("year")
  }, []);

  const { error } = Modal;

  const validate = (values) => {
    const errors = {};
    const { leaveTypeId, startDate, endDate, durationType } = values;

    // if (!leaveTypeId) {
    //   errors.leaveTypeId = `${t('common.pleaseSelect')} ${t('my_request.label.work-type')}`;
    // }

    if (!startDate) {
      errors.startDate = `${t('othersetting.please-enter')} ${t('my_request.label.start-offsite-work-date')}`;
    }

    if (durationType === 'ALLDAY') {
      if (!endDate) {
        errors.endDate = `${t('othersetting.please-enter')} ${t('my_request.label.end-offsite-work-date')}`;
      } else {
        const startDateFormat = dayjs(startDate).startOf('day');
        const endDateFormat = dayjs(endDate).startOf('day');

        if (!endDateFormat.isAfter(startDateFormat) && !endDateFormat.isSame(startDateFormat)) {
          errors.endDate = `${t('common.please-check')} ${t('my_request.label.end-offsite-work-date')}`;
        }

        // const maxEndFormat = dayjs(maxEnd).startOf('day');
        // if (!endDateFormat.isBefore(maxEndFormat) && !endDateFormat.isSame(maxEndFormat)) {
        //   errors.endDate = ` ${t('common.please-check')} ${t('my_request.label.end-offsite-work-date')}`;
        // }
      }
    }

    // if (!values.description) {
    //   errors.description = t('othersetting.please-enter');
    // }

    if (!durationType) {
      errors.durationType = `${t('common.pleaseSelect')} ${t('leave_type.label.duration')}`;
    }

    return errors;
  };

  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
    },
    [setMenu]
  );

  function getItem(label, key,) {
    return {
      label: label,
      key: key,
    };
  }

  const MENU = [
    getItem(t("leave_type.label.detail"), MY_REQUEST_TYPE.DETAIL),
    (modalType === MODAL_TYPE.VIEW && initialValues?.approveStatusEn !== 'Draft') ? getItem(t("leave_type.label.approvalSequence"), MY_REQUEST_TYPE.APPROVALSEQ) : null,
    (modalType === MODAL_TYPE.VIEW && (initialValues?.timelineReject?.length > 0)) ? getItem(t("leave_type.label.approvalReqSequence"), MY_REQUEST_TYPE.APPROVALREJECTSEQ) : null,
  ];

  const LeaveSchema = Yup.object().shape({
    leaveTypeId: Yup.string().required("Please select."),
    description: Yup.string().required("Please enter."),
  });
  const LeaveSchemaReject = Yup.object().shape({
    // leaveTypeId: Yup.string().required("Please select."),
    descriptionReject: Yup.string().required("Please enter."),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...INITIAL_VALUES, ...initialValues
      }}
      onSubmit={(values, { resetForm }) => { initialValues.reject == 'reject' ? onReject(values) : onSubmit(values, resetForm) }}
      validate={validate}
      validationSchema={() =>
        initialValues.reject === 'reject' ? LeaveSchemaReject : LeaveSchema
      }
    >
      {({ values = {}, resetForm = () => { }, setFieldValue = () => { }, getFieldMeta = () => { } }) => {

        const selectedOption = leaveGroupOptions?.find(
          (option) => option?.leaveId === values?.leaveTypeId
        );
        if (selectedOption?.unlimited === 'N') {
          setRemainingLeaveDays(selectedOption?.remainingLeaveDays || 0)
          setRemainingLeaveHour(convertLeaveHour(selectedOption?.remainingLeaveHour || 0))
        } else {
          setRemainingLeaveDays(t("unlimited"));
          setRemainingLeaveHour(t("unlimited"));
        }

        const leaveGroupActiveOptions = leaveGroupOptions?.filter?.((col) => col.statusFlag === 'ACTIVE');
        let language = i18n.language === 'en' ? "En" : ""

        return (

          <Form className={className}>
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
              <Flex gap={10} vertical={true} >
                <ConfigProvider
                  theme={{
                    components: {
                      Tabs: {
                        itemHoverColor: "var(--tab-color)",
                        itemActiveColor: "var(--tab-color)"
                      },
                    },
                  }}
                >
                  <Tabs items={MENU} onChange={(e) => { handleMenuChange(e); setCurrentMenu(e); }} />
                </ConfigProvider>

                {(selectedMenu === MY_REQUEST_TYPE.DETAIL && (modalType === MODAL_TYPE.CREATE || modalType === MODAL_TYPE.EDIT)) && (
                  <>
                    <Col span={24}>
                      <Select
                        disabled={modalType == 'view'}
                        required
                        name="leaveTypeId"
                        label={t('leave_type.label.leave_type')}
                        placeholder={t('common.pleaseSelect')}
                        size="large"
                        options={leaveGroupActiveOptions}
                        // onChange={handleLeaveTypeChange}
                        onChange={(val, option) => {

                          setFieldValue("startDate", null)
                          setFieldValue("endDate", null)

                          setFieldValue("minimumLeave", option?.minimumLeave)
                          setFieldValue("accumulatedAnnualLeave", option?.accumulatedAnnualLeave)
                          setFieldValue("allowOnce", option?.allowOnce)
                          setFieldValue("attachment", option?.attachment)
                          setFieldValue("avalibleInBirth", option?.avalibleInBirth)
                          setFieldValue("consecutiveLimit", option?.consecutiveLimit)
                          setFieldValue("countHolidays", option?.countHolidays)
                          setFieldValue("diligenceAllowance", option?.diligenceAllowance)
                          setFieldValue("docLimitPerDay", option?.docLimitPerDay)
                          setFieldValue("gender", option?.gender)
                          setFieldValue("halfDayLeave", option?.halfDayLeave)
                          setFieldValue("includeProbation", option?.includeProbation)
                          setFieldValue("leaveWithoutPay", option?.leaveWithoutPay)
                          setFieldValue("maxLeaveAccum", option?.maxLeaveAccum)
                          setFieldValue("maxLeaveAccumLastYear", option?.maxLeaveAccumLastYear)
                          setFieldValue("maximumConsecutiveLeave", option?.maximumConsecutiveLeave)
                          setFieldValue("minimumLeave", option?.minimumLeave)
                          setFieldValue("permanentOnly", option?.permanentOnly)
                          setFieldValue("whenLeavingSince", option?.whenLeavingSince)
                          setFieldValue("advanceAtLeast", option?.advanceAtLeast)
                          // setFieldValue("attachFile", imageUrl ? imageUrl : null)
                          setFieldValue("unlimited", option?.unlimited)
                          setFieldValue("remainingLeaveDays", option?.remainingLeaveDays)
                          setFieldValue("remainingLeaveHour", option?.remainingLeaveHour)

                          setFieldValue("emergencyLeave", option?.emergencyLeave)
                          setFieldValue("emergencyUsed", option?.emergencyUsed ? option?.emergencyUsed : 0)
                          setFieldValue("backDateWithin", option?.backDateWithin)
                          setFieldValue("requestCondition", option?.requestCondition)
                          setFieldValue("annualLeaveLimit", option?.annualLeaveLimit)

                          if (option?.unlimited === 'N') {
                            setremainingLeaveDays(option ? option?.remainingLeaveDays : 0);
                            setRemainingLeaveDays(option ? option?.remainingLeaveDays : 0);
                            setRemainingLeaveHour(convertLeaveHour(option ? option?.remainingLeaveHour : 0));

                          } else {
                            setRemainingLeaveDays(t("unlimited"));
                            setRemainingLeaveHour(t("unlimited"));
                          }


                        }}
                      />
                    </Col>

                    {values?.emergencyLeave === 'Y' && values?.annualLeaveLimit - values?.emergencyUsed >= 0 ?

                      <Col span={24}>
                        <label> {t('leave_type.label.use-emergency-leave')}  </label>
                        <Checkbox name="emergencyFlag"
                          disabled={modalType == 'view'}
                          onChange={(e) => {
                            setFieldValue("emergencyFlag", e.target.checked ? 'Y' : 'N');
                            setFieldValue("startDate", null)
                            setFieldValue("endDate", null)
                          }}
                        >
                        </Checkbox>
                      </Col> : null}
                    <Row>
                      <Col span={12} style={{ paddingRight: "0.5vw" }}>
                        <Input
                          readOnly
                          name="totalLeaveDays"
                          label={t('leave_type.label.remaining-leave-day')}
                          placeholder={remainingLeaveDays}
                          size="large"
                          subclassName={styles.alignRight}
                        />
                      </Col>

                      <Col span={12} style={{ paddingLeft: "0.5vw" }}>
                        <Input
                          readOnly
                          name="totalLeaveHourShow"
                          label={t('leave_type.label.remaining-leave-hour')}
                          placeholder={remainingLeaveHour}
                          size="large"
                          subclassName={styles.alignRight}
                        />
                      </Col>
                    </Row>
                    <Flex>
                      <Col span={24}>
                        <RadioGroup
                          disabled={modalType == 'view'}
                          required
                          name="durationType"
                          label={t('leave_type.label.duration')}
                          options={[
                            {
                              label: t('leave_type.label.all-day'),
                              value: "ALLDAY",
                            },
                            {
                              label: t('leave_type.label.hour'),
                              value: "HOUR",
                            },
                          ]}
                        />
                      </Col>
                    </Flex>
                    {values.durationType === "ALLDAY" ? (
                      <>
                        <Col span={24}>
                          <DatePicker
                            required
                            disabled={modalType == 'view'}
                            name="startDate"
                            label={t('leave_type.label.start_leave_date')}
                            placeholder={t('common.placeholder.ddmmyyyy')}
                            size="large"
                            format={formatDate()}
                            min={calculateMinStartDate(values)}
                            max={calculateMaxStartDate(values)}
                            onChange={() => {
                              setFieldValue("endDate", null)
                            }}
                          />
                        </Col>
                        <Col span={24}>
                          <DatePicker
                            disabled={modalType == 'view'}
                            required
                            name="endDate"
                            label={t('leave_type.label.end-leave-date')}
                            placeholder={t('common.placeholder.ddmmyyyy')}
                            size="large"
                            format={formatDate()}
                            min={calculateMinEndDate(values)}
                            max={calculateMaxEndDate(values)}
                          />
                        </Col>
                      </>
                    ) : values?.durationType && (
                      <>
                        <Col span={values?.requestCondition?.code !== 'LEAVE_REQUEST_CONDITION_03' ? 24 : 24}>
                          <DatePicker
                            disabled={modalType == 'view'}
                            required
                            name="startDate"
                            label={t('leave_type.label.leave-date')}
                            placeholder={t('common.placeholder.ddmmyyyy')}
                            size="large"
                            format={formatDate()}
                            onChange={(e) => {

                              setFieldValue('endDate', e)
                            }}
                            min={validateDaysMin(values)}
                          />
                        </Col>
                        {/* {values?.requestCondition?.code !== 'LEAVE_REQUEST_CONDITION_03' &&
                          <Tooltip placement="bottom" title={[
                            values?.advanceAtLeast ? t('advance-at-least') + values?.advanceAtLeast + " " + t('days') : "",
                            values?.backDateWithin ? t('back-date-within') + values?.backDateWithin + " " + t('days') : ""
                          ]} >
                            <InfoCircleOutlined />
                          </Tooltip>} */}
                        <Flex>
                          <Col span={12} style={{ paddingRight: "0.5vw" }}>
                            <TimePicker
                              disabled={modalType === 'view'}
                              name="startTime"
                              label={t('leave_type.label.start-time')}
                              suffeicon={false}
                              format="HH:mm:ss"
                              size="large"
                            // mindate={dayjs(values?.startTime, "HH:mm:ss")}
                            // onChange={(e) => {
                            //   setFieldValue("endTime", e)
                            // }}
                            />
                          </Col>
                          <Col span={12} style={{ paddingLeft: "0.5vw" }}>
                            <TimePicker
                              disabled={modalType == 'view'}
                              name="endTime"
                              label={t('leave_type.label.end-time')}
                              suffeicon={false}
                              format="HH:mm:ss"
                              size="large"
                            // mindate={dayjs(values?.startTime, "HH:mm:ss").add(values?.minimumLeave || 0, "minute")}
                            />
                          </Col>
                        </Flex>
                      </>
                    )}
                    <Col span={24}>
                      <Input
                        readOnly={modalType == 'view'}
                        required
                        name="description"
                        label={t('expense.lable.description')}
                        placeholder={t('description.please_enter_description')}
                        size="large"
                        autoComplete="off"
                      />
                    </Col>
                    {selectedOption?.attachment === 'Y' &&
                      <div>
                        <>
                          <><Dragger
                            disabled={modalType === 'view'}
                            name="attachFile"
                            multiple={false}
                            showUploadList={false}
                            onRemove={(e) => {
                              onDeleteFile();
                            }}
                            onChange={(e) => {
                              console.log("e.event", e.event);
                              if (e.event) {
                                onAttachFileChange({
                                  attachFile: e,
                                  setFieldValue,
                                  setImageUrl,
                                  seeFileName,
                                  initialValuesImageUrl,
                                  initialValuesFileName,
                                  initialValuesFileType,
                                  initialValuesFileList,
                                  setInitialValuesFileName,
                                  setInitialValuesFileType,
                                  setInitialValuesImageUrl,
                                  setInitialValuesFileList,
                                  setFileType
                                });
                              }
                            }}
                            style={{
                              border: "1px solid #EAECF0",
                              borderRadius: "10px",
                              background: "#FAFAFA",
                              padding: "20px",
                            }}
                          >
                            <p className="ant-upload-drag-icon">
                              <CloudUploadOutlined style={{ fontSize: "32px", color: "#888" }} />
                            </p>
                            <p
                              className="ant-upload-text"
                              style={{ fontSize: "16px", fontWeight: "500", color: "#4A4A4A" }}
                            >
                              {t("description.Select the desired file or drag and drop")}
                            </p>
                          </Dragger>
                          </>
                          <p>{t('description.Supported files mb')}</p></></div>
                    }
                    {imageUrl && (
                      <>
                        {imageUrl?.map((attachFile, index) => (
                          <>
                            {index === 0 && (
                              <Col span={24}>
                                <label className={cx("label", styles.label)}>
                                  {t('employee.label.attachment-file')}
                                </label>
                              </Col>
                            )}

                            <Row>
                              <div
                                style={{
                                  border: "2px solid var(--button-color)",
                                  borderRadius: "10px",
                                  padding: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  width: "100%",
                                  maxWidth: "500px",
                                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                  marginTop: "10px"
                                }}
                              >
                                <a
                                  onClick={() => { openBase64InNewTab(attachFile, fileType[index]) }}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    textDecoration: "none",
                                  }}
                                >
                                  <img
                                    src={attachFile}
                                    alt="uploaded"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.style.display = "none";
                                      const fallbackElement = e.target.nextElementSibling;
                                      if (fallbackElement) fallbackElement.style.display = "block";
                                    }}
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      objectFit: "cover",
                                      borderRadius: "5px",
                                      marginRight: "10px",
                                    }}
                                  />
                                  <div style={{ flex: 1 }}>
                                    <div style={{ fontWeight: "bold", color: "#333", width: "350px" }}>{fileName[index]}</div>
                                    <div style={{ fontSize: "12px", color: "#888" }}>{fileSizeInMB[index]} MB</div>
                                  </div>
                                </a>
                                <Button
                                  type="default"
                                  style={{
                                    background: "none",
                                    border: "none",
                                    color: "#888",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}

                                  onClick={() => {
                                    const newImage = imageUrl.filter((_, i) => i !== index);
                                    const newfileName = fileName.filter((_, i) => i !== index);
                                    const newfileSize = fileSizeInMB.filter((_, i) => i !== index);
                                    const newfileType = fileType.filter((_, i) => i !== index);

                                    setImageUrl(newImage);
                                    seeFileName(newfileName);
                                    setfileSizeInMB(newfileSize)
                                    setInitialValuesFileName(newfileName)
                                    setInitialValuesImageUrl(newImage)
                                    setInitialValuesFileType(newfileType)
                                    setInitialValuesFileList(values.attachFile.filter((_, i) => i !== index))
                                    setFieldValue("attachFile", values.attachFile.filter((_, i) => i !== index));
                                    setFieldValue("attachFileType", values.attachFileType.filter((_, i) => i !== index));
                                    setFieldValue("attachFileName", values.attachFileName.filter((_, i) => i !== index));
                                  }}
                                >
                                  &#x2715;
                                </Button>
                              </div >
                            </Row >
                          </>
                        ))}
                      </>
                    )
                    }
                  </>

                )}

                {(selectedMenu === MY_REQUEST_TYPE.DETAIL && modalType === MODAL_TYPE.VIEW) && (
                  <>
                    {approvalPage ?
                      <>
                        <Row>
                          <Col span={11}>
                            <Input
                              disabled={true}
                              name={i18n.language === "en" ? "employeeId.nameAndSurnameEn" : "employeeId.nameAndSurname"}
                              label={t('translation.employee.employee')}
                              placeholder={t('translation.employee.employee')}
                              size="large"
                              autoComplete="off"
                            />
                          </Col>
                          <Col span={11} offset={2}>
                            <DatePicker
                              disabled={true}
                              name="createDate"
                              label={t('leave_type.label.createDate')}
                              placeholder={t('common.placeholder.ddmmyyyy')}
                              size="large"
                              format={formatDate()}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col span={11}>
                            <Select
                              disabled={true}
                              name="leaveTypeId"
                              label={t('leave_type.label.leave_type')}
                              placeholder={t('common.pleaseSelect')}
                              size="large"
                              options={leaveGroupActiveOptions}
                            />
                          </Col>
                        </Row>
                      </>
                      :
                      <Row>
                        <Col span={11}>
                          <Select
                            disabled={true}
                            name="leaveTypeId"
                            label={t('leave_type.label.leave_type')}
                            placeholder={t('common.pleaseSelect')}
                            size="large"
                            options={leaveGroupActiveOptions}
                          />
                        </Col>
                        <Col span={11} offset={2}>
                          <DatePicker
                            disabled={true}
                            name="createDate"
                            label={t('leave_type.label.createDate')}
                            placeholder={t('common.placeholder.ddmmyyyy')}
                            size="large"
                            format={formatDate()}
                          />
                        </Col>
                      </Row>}

                    <Row>
                      <Col span={24}>
                        <Input
                          disabled={true}
                          type=""
                          name="timeShiftDtosTH"
                          label={t('leave_type.label.dateOfRequest')}
                          placeholder={t('leave_type.label.dateOfRequest')}
                          size="large"
                          autoComplete="off"
                          rows="4"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={11}>
                        <Input
                          disabled={true}
                          name="totalLeaveDayString"
                          label={t('leave_type.label.duration')}
                          placeholder={t('leave_type.label.duration')}
                          size="large"
                          autoComplete="off"
                        />
                      </Col>
                      <Col span={11} offset={2}>
                        <label className={cx("label", styles.label)}>
                          {t('leave_type.label.leave_status')}
                        </label>
                        <Col span={24} style={{ marginTop: "10px" }}>
                          <StatusTag value={(values?.["approveStatus" + language])} />
                        </Col>
                      </Col>
                    </Row>
                    <Row>

                      {selectedOption?.attachment === 'Y' && !imageUrl ? (
                        <>
                          <Col span={24} >
                            <label className={cx("label", styles.label)}>
                              {t('employee.label.attachment-file')}
                            </label>
                          </Col>
                          <><Dragger
                            disabled={true}
                            name="attachFile"
                            multiple={false}
                            onRemove={() => {
                              onDeleteFile();
                            }}
                            onChange={(e) => {
                              onAttachFileChange({
                                attachFile: e,
                                setFieldValue,
                                setImageUrl,
                                seeFileName,
                                initialValuesImageUrl,
                                initialValuesFileName,
                                initialValuesFileType,
                                initialValuesFileList
                              });
                            }}
                            style={{
                              border: "1px solid #EAECF0",
                              borderRadius: "10px",
                              background: "#FAFAFA",
                              padding: "20px",
                            }}
                          >
                            <p className="ant-upload-drag-icon">
                              <CloudUploadOutlined style={{ fontSize: "32px", color: "#888" }} />
                            </p>
                            <p
                              className="ant-upload-text"
                              style={{ fontSize: "16px", fontWeight: "500", color: "#4A4A4A" }}
                            >
                              {t("description.Select the desired file or drag and drop")}
                            </p>
                          </Dragger>
                          </>
                          <p>{t('description.Supported files mb')}</p></>
                      ) :
                        imageUrl ? (
                          <>
                            {imageUrl?.map((attachFile, index) => (
                              <>
                                {index === 0 && (
                                  <Col span={24}>
                                    <label className={cx("label", styles.label)}>
                                      {t('employee.label.attachment-file')}
                                    </label>
                                  </Col>
                                )}
                                <div
                                  style={{
                                    border: "2px solid var(--button-color)",
                                    borderRadius: "10px",
                                    padding: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    maxWidth: "500px",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                    marginTop: "10px"
                                  }}
                                >
                                  <a
                                    href={attachFile}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      textDecoration: "none",
                                    }}
                                  >
                                    <img
                                      src={attachFile}
                                      alt="uploaded"
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.style.display = "none";
                                        const fallbackElement = e.target.nextElementSibling;
                                        if (fallbackElement) fallbackElement.style.display = "block";
                                      }}
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        objectFit: "cover",
                                        borderRadius: "5px",
                                        marginRight: "10px",
                                      }}
                                    />
                                    <div style={{ flex: 1 }}>
                                      <div style={{ fontWeight: "bold", color: "#333", width: "350px" }}>{fileName[index]}</div>
                                      <div style={{ fontSize: "12px", color: "#888" }}>{fileSizeInMB[index]} MB</div>
                                    </div>
                                  </a>
                                </div>
                              </>
                            ))}
                          </>

                        ) : null
                      }
                    </Row>
                    <Row>
                      <Col span={24}>
                        <Input
                          disabled={true}
                          name="description"
                          label={t('leave_type.label.note')}
                          placeholder={t('leave_type.label.note')}
                          size="large"
                          autoComplete="off"
                          type=""
                          rows="4"
                        />
                      </Col>
                    </Row>
                    {((initialValues.reject == 'reject') || (Array.isArray(initialValues.timelineReject) && initialValues?.timelineReject?.length > 0)) &&
                      <Row>
                        <Col span={24}>
                          <Input
                            disabled={initialValues.reject != 'reject'}
                            type=""
                            name="descriptionReject"
                            label={t('leave_type.label.noteReject')}
                            placeholder={t('leave_type.label.noteReject')}
                            size="large"
                            autoComplete="off"
                            required
                          />
                        </Col>
                      </Row>
                    }

                    {approveType === REQUEST_APPROVE_TAB.LEAVE && (
                      <Row justify="end">
                        <Space size={12} className={styles.filterbtn}>
                          <Button
                            type="default"
                            onClick={() => {
                              onReject()
                            }}
                            style={{
                              height: "40px", borderRadius: "8px",
                              padding: "8px 16px"
                            }}>
                            {t("action.reject")}
                          </Button>
                          <Button
                            type="primary"
                            onClick={() => {
                              onApprove()
                            }}
                            style={{
                              height: "40px", borderRadius: "8px",
                              backgroundColor: "var(--button-color)",
                              padding: "8px 16px"
                            }}>
                            {t("action.approve")}
                          </Button>
                        </Space>
                      </Row>
                    )}
                  </>

                )}

                {selectedMenu === MY_REQUEST_TYPE.APPROVALSEQ && (
                  <>
                    {Array.isArray(currentWorkflow) &&
                      currentWorkflow?.map((workflow, index) => (
                        <>
                          <label>{`${t('leave_type.label.sequence')} ${index + 1}`}</label>
                          <Card size="small" key={index} style={{ border: "1px solid #000" }}>
                            <Row>
                              <Col span={16}>
                                <label style={{ color: "#667085" }}>{`${t('leave_type.label.approver')}`}</label>
                              </Col>
                              <Col span={8}>
                                <span style={{ color: "#667085", display: "flex", justifyContent: "flex-end" }}>{t("leave_type.label.approvalDate")}</span>
                              </Col>
                              <Col span={16}>
                                <span>{workflow?.listEmployees?.slice(0, 3).join(" , ")}</span>
                                <> </>
                                {workflow?.listEmployees?.length > 3 ? (
                                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                  <a
                                    onClick={() => {
                                      setOpenListEmployee(true);
                                      setListEmployees(workflow?.listEmployees);
                                    }}
                                    style={{
                                      display: "inline-block",
                                      borderRadius: "36px",
                                      padding: "4px 12px",
                                      fontSize: "0.7vw",
                                      color: "#fff",
                                      background: "var(--primary-color)",
                                      textDecoration: "none",
                                      fontWeight: "bold",
                                      border: "1px solid var(--primary-color)",
                                      cursor: "pointer"
                                    }}

                                  >
                                    {`+ ${workflow?.listEmployees?.length - 3} ...`}
                                  </a>
                                ) : ""}
                              </Col>
                              <Col span={8}>
                                <span style={{ display: "flex", justifyContent: "flex-end" }}>{workflow?.approveDate ? formatDateTime(workflow?.approveDate) : "-"}</span>
                              </Col>
                            </Row>
                            <Row >
                              <Col span={16} style={{ marginTop: '10px' }}>
                                <label>
                                  {workflow?.workFlowtype}
                                </label></Col>
                              <Col span={8} style={{ marginTop: '10px' }} >
                                <label style={{ display: "flex", justifyContent: "flex-end" }}> <StatusTag value={(workflow?.["approveStatus" + language])} /> </label>
                              </Col>
                            </Row>
                          </Card >
                        </>
                      ))}
                  </>
                )}
                {selectedMenu === MY_REQUEST_TYPE.APPROVALREJECTSEQ && (
                  <>
                    {Array.isArray(initialValues.timelineReject) && initialValues?.timelineReject?.length > 0 &&
                      fnRejectFor(initialValues)
                    }
                  </>
                )}
              </Flex>

              {openListEmployee && (
                <Modal title={t("leave_type.label.approver")}
                  open={openListEmployee}
                  onCancel={() => setOpenListEmployee(false)}
                  footer={false}
                  width="510px"
                  maskClosable={false}
                >
                  <Card size="small" style={{ border: "1px solid #000" }}>
                    {listEmployees?.map((employee, index) => (
                      <label key={index}>
                        {employee}
                        <br />
                      </label>
                    ))}
                  </Card>
                </Modal>
              )}

              {standAlone == true &&
                <Flex justify="end" >
                  <Space direction="horizontal" size={12}>
                    <Button
                      id="mst__cancelBtn"
                      type="default"
                      style={{ height: "40px", borderRadius: "8px" }}
                      onClick={() => {
                        resetForm();
                        onCancel();
                      }}
                    >
                      {t("common.cancel")}
                    </Button>
                    {(initialValues.reject == 'reject' && useCurrentMenu == MY_REQUEST_TYPE.DETAIL) &&
                      <Button
                        htmlType="submit"
                        disabled={!values.leaveTypeId}
                        onClick={() => {
                          setFieldValue("sendingType", "SUBMIT");

                        }}
                        type="primary"
                        style={{ height: "40px", borderRadius: "8px", backgroundColor: !values.leaveTypeId ? "" : "var(--button-color)", boxShadow: "none" }}
                      >
                        {t("common.reject")}
                      </Button>
                    }
                    {modalType != 'view' ?
                      <><Button
                        id="mst__cancelBtn"
                        type="default"
                        htmlType="submit"
                        disabled={!values.leaveTypeId}
                        onClick={async () => {
                          setFieldValue("sendingType", "DRAFT");
                        }}
                        style={{ height: "40px", borderRadius: "8px" }}
                      >
                        {t("common.draft")}
                      </Button>
                        {modalType === MODAL_TYPE.EDIT && values.sendingType === 'DRAFT' ?
                          <Button
                            type="default"
                            style={{ height: "40px", borderRadius: "8px", color: "red", borderColor: "red" }}
                            onClick={() => {
                              resetForm();
                              onDelete(values);
                            }}
                          >
                            {t("common.delDraft")}
                          </Button>
                          : null}
                        <Button
                          // className='primary-submit'
                          htmlType="submit"
                          disabled={!values.leaveTypeId}
                          onClick={() => {
                            setFieldValue("sendingType", "SUBMIT");

                            // if (values?.attachFile && values?.attachFile[0]) {
                            //   console.log("🚀 ~ values:", values)
                            //   const fileList = []
                            //   for (let index = 0; index < values?.attachFile?.length; index++) {
                            //     const element = values?.attachFile[index];
                            //     console.log("🚀 ~ element:", element)

                            //     const File = base64ToFile(element, element.name, element.type);
                            //     fileList.push(File)
                            //   }
                            //   setFieldValue("attachFile", fileList);
                            // }
                          }}
                          type="primary"
                          style={{ height: "40px", borderRadius: "8px", backgroundColor: !values.leaveTypeId ? "" : "var(--button-color)", boxShadow: "none" }}
                        >
                          {t("my_timesheet.label.approve")}
                        </Button>
                      </>
                      : null}

                  </Space>
                </Flex>
              }
            </Space>
          </Form>
        );
      }}
    </Formik >
  );
}

export default LeaveForm;
